// „Als App installieren“: Chrome & Co. bieten das an, sobald Manifest und Service Worker da sind
// (Ereignis beforeinstallprompt); Safari auf dem iPhone kann das nicht – dort hilft eine kurze Anleitung.
type Prompt = Event & { prompt(): Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> };

let prompt: Prompt | null = null;

export const isIos = (ua: string) => /iPhone|iPad|iPod/.test(ua);

/** läuft schon als installierte App (ohne Adressleiste) */
export const isStandalone = () =>
  matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;

export const canInstall = () => !!prompt && !isStandalone();
export const needsIosHint = () => isIos(navigator.userAgent) && !isStandalone();

export async function install(redraw: () => void) {
  if (!prompt) return;
  await prompt.prompt();
  await prompt.userChoice;
  prompt = null;
  redraw();
}

/** Service Worker anmelden und das Angebot zum Installieren abfangen; nur in sicherem Kontext (https, localhost) */
export function initInstall(redraw: () => void) {
  addEventListener('beforeinstallprompt', e => {
    e.preventDefault();
    prompt = e as Prompt;
    redraw();
  });
  addEventListener('appinstalled', () => ((prompt = null), redraw()));
  if (isSecureContext && 'serviceWorker' in navigator) void navigator.serviceWorker.register('sw.js').catch(() => {});
}
